import React, { Component } from 'react';
import { bool, func, string, object } from 'prop-types';

import { connect } from 'react-redux';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';

import EsmsModal from '../../components/EsmsModal';
import CancelButton from '../../components/CancelButton';
import ConfirmButton from '../../components/ConfirmButton';

import validator from '../../helpers/validator';

import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as BasAgentActions from '../../actions/basAgentActions';

import classes from './RenameAgentModal.module.css';

class RenameAgentModal extends Component {
    state = {
        formIsValid:  false,
        formControls: {
            name: {
                value:           '',
                placeholder:     'Agent Name',
                valid:           false,
                touched:         false,
                message:         '',
                validationRules: {
                    isRequired: true
                }
            }
        }
    }

    resetModal = () => {
        const agentName = this.props.agent.name;
        const updatedControls = {
            ...this.state.formControls
        };

        const isPopulated = ((agentName.trim && agentName.trim()) ? true : false);

        updatedControls.name.value = (agentName.trim()) ? agentName : '';
        updatedControls.name.touched = isPopulated;
        updatedControls.name.valid = isPopulated;

        this.setState({
            formControls:    updatedControls,
            formIsPopulated: isPopulated,
            formIsValid:     isPopulated
        });
    }

    handleValidation = event => {
        const validatedState = validator(this.state, event);

        this.setState({
            formControls: validatedState.updatedControls,
            formIsValid:  validatedState.formIsValid
        });
    }

    handleChange = event => {
        const value = event.target.value;
        const name = event.target.name;

        const updatedControls = { ...this.state.formControls };

        updatedControls[name].value = value;

        this.setState({
            event:        { ...event },
            formControls: updatedControls
        });
    }

    handleUpdate = async () => {
        const updates = {name: this.state.formControls.name.value};
        const { companyInfo, agent, updateBasAgent } = this.props;

        const isRenamed = await updateBasAgent(companyInfo.companyId, agent.id, updates);

        if (isRenamed) this.handleClose();
    }

    handleClose = () => {
        this.props.clearErrors();

        this.props.close();
    }

    render() {
        let { errors, open, title } = this.props;


        return (
            <EsmsModal
                errors={errors}
                imgSrc="/assets/images/basAgentIconColor.svg"
                open={open}
                onClose={this.handleClose}
                title={title}
                onRendered={this.resetModal}
            >
                <p>
                    Please enter the new name for this Agent.
                </p>
                <FormControl className={classes.fullWidth}>
                    <InputLabel
                        htmlFor="name"
                        classes={{
                            focused: classes.labelFocused,
                            root:    classes.label
                        }}
                    >
                        {this.state.formControls.name.placeholder}
                    </InputLabel>
                    <Input
                        id="name"
                        name="name"
                        value={this.state.formControls.name.value}
                        onChange={this.handleChange}
                        classes={{
                            underline: classes.cssUnderline,
                            root:      classes.input
                        }}
                        inputProps={{
                            onBlur: this.handleValidation
                        }}
                    />
                    {!this.state.formControls.name.valid &&
                                  this.state.formControls.name.touched && <FormHelperText className={classes.error}>{this.state.formControls.name.message}</FormHelperText>}
                </FormControl>
                <div className={classes.buttonContainer}>
                    <CancelButton cancel={this.handleClose} />
                    <ConfirmButton
                        confirm={this.handleUpdate}
                        label="Rename"
                        type="button"
                        disabled={!this.state.formIsValid}
                    />
                </div>
            </EsmsModal>
        );
    }
}

RenameAgentModal.propTypes = {
    agent: object.isRequired,
    close: func.isRequired,
    open:  bool.isRequired,
    title: string.isRequired
};

const mapStateToProps = state => {
    return {
        companyInfo: state.companyInfo,
        errors:      state.messages.errors
    };
};

const mapDispatchToProps = {
    ...ApplicationMessageActions,
    ...BasAgentActions
};

export default connect(mapStateToProps, mapDispatchToProps)(RenameAgentModal);
